import React from 'react'
// @ts-ignore
import cn from './cn.module.css'

const CheckboxSmallText: React.FC<any> = (props) => {
  return <p className={cn.checkboxAftertit}>{props.text}</p>
}
export default CheckboxSmallText
